// The name of each sequence step type, in one place.
//
// Both the sequence editor (PRODUCT_T) and the task board (TASK_BOARD_T) spread
// this in, so a step is called the same thing wherever it appears and
// `STEP_META.labelKey` resolves against either map. Adding a step type here is
// what makes it nameable on both surfaces at once.
export const STEP_LABEL_T = {
  pipelineStepEmail: { FR: "Email", EN: "Email" },
  pipelineStepCall: { FR: "Appel", EN: "Call" },
  pipelineStepLinkedinInvite: {
    FR: "Invitation LinkedIn",
    EN: "LinkedIn invitation",
  },
  pipelineStepLinkedinInviteCheck: {
    FR: "Invitation acceptée ?",
    EN: "Invitation accepted?",
  },
  pipelineStepLinkedinMessage: {
    FR: "Message LinkedIn",
    EN: "LinkedIn message",
  },
  pipelineStepInstagramMessage: {
    FR: "Message Instagram",
    EN: "Instagram message",
  },
  pipelineStepWhatsappMessage: {
    FR: "Message WhatsApp",
    EN: "WhatsApp message",
  },
  pipelineInstagramMessageHint: {
    FR: "Message rédigé par l'IA, envoyé au compte Instagram du contact ou de l'entreprise.",
    EN: "Message written by the AI, sent to the contact's or the company's Instagram account.",
  },
  pipelineWhatsappMessageHint: {
    FR: "Message rédigé par l'IA, envoyé sur WhatsApp à un numéro de mobile.",
    EN: "Message written by the AI, sent on WhatsApp to a mobile number.",
  },
  pipelineInstagramTemplateToggle: {
    FR: "Modèle du message Instagram",
    EN: "Instagram message template",
  },
  pipelineWhatsappTemplateToggle: {
    FR: "Modèle du message WhatsApp",
    EN: "WhatsApp message template",
  },
  pipelineCallTemplateToggle: {
    FR: "Modèle du script d'appel",
    EN: "Call script template",
  },
  // Several calls read one script by default: the AI drafts it once per contact.
  pipelineCallScriptShared: {
    FR: "Même script pour tous les appels",
    EN: "Same script for every call",
  },
  pipelineCallScriptSharedNote: {
    FR: "Même script que l'appel 1.",
    EN: "Same script as call 1.",
  },
  // A blank call block is not missing: the call then simply has no script.
  pipelineCallTemplateOptional: {
    FR: "Facultatif : vide, l'appel n'a pas de script",
    EN: "Optional: left blank, the call has no script",
  },
  pipelineStepFileUpload: {
    FR: "Ajout de fichier",
    EN: "File upload",
  },
} as const

export type StepLabelKey = keyof typeof STEP_LABEL_T
